import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
  makeStyles,
} from "@material-ui/core";
import { appUrl } from "../../../../../../utils/config";

import axios from "axios";
import {
  dateFormated,
  presentFormatedData,
} from "../../functionalComponents/dataFormatFunctions";
import { downloadCustomUploadedFile } from "../../../../containers/actions/common/fileActions";
import { useDispatch } from "react-redux";

const useStyles = makeStyles({
  tableContainer: {
    margin: "20px",
    maxWidth: "90%",
    border: "1px solid #ccc",
    borderRadius: "8px",
  },
  headerCell: {
    fontWeight: "bold",
    backgroundColor: "#f5f5f5",
    padding: "12px 16px",
  },
  bodyCell: {
    padding: "12px 16px", // Same padding as header
  },
  linkContainer: {
    display: "flex",
    flexDirection: "column", // Makes links stack vertically
  },

  link: {
    color: "#1a0dab", // Ensures link matches mockup color
    textDecoration: "none", // Removes underline by default
    "&:hover": {
      textDecoration: "underline", // Adds underline on hover
    },
  },
});

const DeliveryDetailsTable = ({ data }) => {
  const classes = useStyles();
  const [documentsList, setDocumentsList] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    axios
      .get(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllFilesForSL/${data?.scheduleLineDetails?.schrockenSLID}` //26195
      )
      .then((res) => {
        if (res.data.status) {
          if (res.data.data) {
            setDocumentsList(filterShippingFiles(res.data.data)); //(mockDocsData));
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // const mockData = {
  //   poDetailsList: [
  //     {
  //       scheduleLineDetails: {
  //         stabilityReqmtSamplingQty: null,
  //         scheduleAgreementNumber: "4500022548",
  //         stabilityReqmtSampling: null,
  //         committedQuantity: 20000,
  //         EUImportationSamplingReqd: null,
  //         storageLocation: "2",
  //         artworkRequired: null,
  //         uom: "BOX",
  //         sponsorProposedQuantity: null,
  //         scheduleLineItemNumber: 10,
  //         requestedQuantity: 20000,
  //         brandOwnerMosymphonyID: 2,
  //         committedDeliveryDate: "2024-10-03T00:00",
  //         requestedDate: "2024-10-03T00:00",
  //         deliveryDate: "2024-10-03T00:00",
  //         sponsorProposedDate: null,
  //         cmoProposedQuantity: null,
  //         brand: null,
  //         productType: null,
  //         cmoProposedDate: null,
  //         scheduleLineStatusText: "Confirmed",
  //         aboRisk: null,
  //         scheduleLineStatusID: 25,
  //         fgMaterialCode: "50065944",
  //         poOrderAcknowledgementNumber: null,
  //         schrockenSLID: 25681,
  //         market: null,
  //         EUImportationSamplingQty: null,
  //         vendorPlant: "CMO1",
  //         cmoSalesOrderNumber: null,
  //         fgMaterialName: "TRANSPACER G",
  //         vendorMosymphonyID: 3,
  //         schrockenSAID: 25535,
  //         targetQuantity: 20000,
  //         vendorName: "Oxford Biomedica Generics Limited",
  //         sponsorName: "Tree Tops Life Sciences Inc",
  //         deliveryAddress: {
  //           street_address_1: "Vihari Homes",
  //           street_address_2: "Navadurga Colony",
  //         },
  //         pickupAddress: {
  //           street_address_1: "sai nagar, vemualawada, karimnagar",
  //           street_address_2: "sai nagar, vemualawada, karimnagar",
  //         },
  //       },
  //       batchDetails: {},
  //     },
  //   ],
  // };
  // const mockDocsData = {
  //   customFiles: [
  //     // Sales Order Files
  //     {
  //       customFileType: "salesOrder",
  //       customFileName: "Sales Order 1.pdf",
  //       schrockenCustomFileID: "8982",
  //       schrockenSLID: 26194,
  //     },
  //     {
  //       customFileType: "salesOrder",
  //       customFileName: "Sales Order 2.pdf",
  //       schrockenCustomFileID: "8982",
  //       schrockenSLID: 26194,
  //     },
  //     {
  //       customFileType: "salesOrder",
  //       customFileName: "Sales Order 3.pdf",
  //       schrockenCustomFileID: "8982",
  //       schrockenSLID: 26194,
  //     },

  //     // Batch Shipping Files
  //     {
  //       customFileType: "batch_shipping",
  //       customFileName: "Batch Shipping 1.pdf",
  //       schrockenCustomFileID: "8982",
  //       schrockenSLID: 26194,
  //     },
  //     {
  //       customFileType: "batch_shipping",
  //       customFileName: "Batch Shipping 2.pdf",
  //       schrockenCustomFileID: "8982",
  //       schrockenSLID: 26194,
  //     },
  //     {
  //       customFileType: "batch_shipping",
  //       customFileName: "Batch Shipping 3.pdf",
  //       schrockenCustomFileID: "8982",
  //       schrockenSLID: 26194,
  //     },

  //     // Artwork Files
  //     {
  //       customFileType: "artwork",
  //       customFileName: "Artwork 1.pdf",
  //       schrockenCustomFileID: "8982",
  //       schrockenSLID: 26194,
  //     },
  //     {
  //       customFileType: "artwork",
  //       customFileName: "Artwork 2.pdf",
  //       schrockenCustomFileID: "8982",
  //       schrockenSLID: 26194,
  //     },
  //     {
  //       customFileType: "artwork",
  //       customFileName: "Artwork 3.pdf",
  //       schrockenCustomFileID: "8982",
  //       schrockenSLID: 26194,
  //     },
  //   ],
  // };

  const filterShippingFiles = (customFiles) =>
    Array.isArray(customFiles?.customFiles)
      ? customFiles.customFiles.filter(
          ({ customFileType }) => customFileType === "batch_shipping"
        )
      : [];

  const handleFileClick = (fileID) => {
    // console.log(`File clicked: ${fileID}`);
    const data = {
      schrockenCustomFileID: fileID,
    };
    dispatch(downloadCustomUploadedFile(data));
  };

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className="default-table-styles">
        <TableHead>
          <TableRow style={{width:"100%"}}>
             {/* <TableCell style={{width:"11%"}} className={classes.headerCell}>Delivery To</TableCell>
            <TableCell style={{width:"11%"}} className={classes.headerCell}>Plant ID</TableCell>
            <TableCell style={{width:"16%"}} className={classes.headerCell}>
              Storage Location ID
            </TableCell>  */}
            <TableCell style={{width:"10%"}} className={classes.headerCell}>Addressee Org</TableCell>
            <TableCell style={{width:"10%"}} className={classes.headerCell}>City</TableCell>
            <TableCell style={{width:"12%"}} className={classes.headerCell}>
            Country
            </TableCell>
            <TableCell style={{width:"14%"}} className={classes.headerCell}>
              Confirmation Control Key
            </TableCell>
            <TableCell style={{width:"17%"}} className={classes.headerCell}>
              Actual CMO Dispatch Date
            </TableCell>
            <TableCell style={{width:"17%"}} className={classes.headerCell}>
              Receipt/Collection Date
            </TableCell>
            <TableCell style={{width:"14%"}} className={classes.headerCell}>
              Attached Documents
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow style={{width:"100%"}}>
            <TableCell style={{width:"10%"}} className={classes.bodyCell}>
              {/* {mockData.poDetailsList[0]?.scheduleLineDetails?.vendorName} */}
              {data?.scheduleLineDetails?.deliveryAddresseeOrgName || "NA"}
            </TableCell>
            {/* <TableCell> */}
            {/* {
                mockData.poDetailsList[0]?.scheduleLineDetails?.deliveryAddress
                  ?.street_address_1
              } */}
            {/* {data?.scheduleLineDetails?.deliveryAddress ? (
                <>
                  {data.scheduleLineDetails.deliveryAddress.street_address_1}
                  <br />
                  {data.scheduleLineDetails.deliveryAddress.street_address_2}
                </>
              ) : (
                "NA"
              )}
            </TableCell> */}

            <TableCell style={{width:"10%"}} className={classes.bodyCell}>
              {data?.scheduleLineDetails?.deliveryAddresseeCity || "NA"}
            </TableCell>
            <TableCell style={{width:"12%"}} className={classes.bodyCell}>
              {data?.scheduleLineDetails?.deliveryAddresseeCountry || "NA"}
            </TableCell>
            <TableCell style={{width:"14%"}} className={classes.bodyCell}>
              {data?.scheduleLineDetails?.supplierConfirmationControlKey || "NA"}
            </TableCell>
             {/* <TableCell style={{width:"11%"}} className={classes.bodyCell}>
              {data?.scheduleLineDetails?.sponsorName || "NA"}
            </TableCell>
             <TableCell style={{width:"11%"}} className={classes.bodyCell}>
              {data?.scheduleLineDetails?.vendorPlant}
            </TableCell>
            <TableCell style={{width:"16%"}} className={classes.bodyCell}>
              {data?.scheduleLineDetails?.storageLocation || "NA"}
            </TableCell> */}
            <TableCell style={{width:"17%"}} className={classes.bodyCell}>
              {dateFormated(
                data?.batchDetails?.dispatchDate,
                "DD-MMM-YYYY",
                "NA"
              )}
            </TableCell>
            <TableCell style={{width:"17%"}} className={classes.bodyCell}>
              {dateFormated(
                data?.batchDetails?.actualDeliveryDate,
                "DD-MMM-YYYY",
                "NA"
              )}
            </TableCell>
            <TableCell style={{width:"14%"}} className={classes.bodyCell}>
              {documentsList.length > 0 ? (
                <div className={classes.linkContainer}>
                  {/* {mockDocsData.documents.map((doc, docIndex) => ( */}
                  {documentsList.map((doc, docIndex) => (
                    <Link
                      key={docIndex}
                      className={classes.link}
                      onClick={() => handleFileClick(doc.schrockenCustomFileID)}
                    >
                      {doc.customFileName}
                    </Link>
                  ))}
                </div>
              ) : (
                <p style={{ color: "gray", fontStyle: "italic" }}>
                  No files available.
                </p>
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DeliveryDetailsTable;
